document.addEventListener("DOMContentLoaded", () => {

    const popup = document.querySelector('.email-coupon-popup');
    if (!popup) return;

    const delay = Number(popup.dataset.delay || 10) * 1000;
    const closeBtn = popup.querySelector(".email-coupon-popup__close");
    const overlay = popup.querySelector('.email-coupon-popup__overlay');

    // localStorage keys
    const CLOSED_KEY = 'coupon_popup_closed';
    const SUBMITTED_KEY = 'coupon_popup_submitted';

    const now = Date.now();

    /* -------------------------
       1. Якщо користувач підписався → ховаємо на 30 днів
    -------------------------- */
    const submittedAt = localStorage.getItem(SUBMITTED_KEY);

    if (submittedAt) {
        const days30 = 30 * 24 * 60 * 60 * 1000;
        if (now - Number(submittedAt) < days30) return;
    }

    /* -------------------------
       2. Якщо користувач закрив попап → ховаємо на 1 годину
    -------------------------- */
    const closedAt = localStorage.getItem(CLOSED_KEY);

    if (closedAt) {
        const oneHour = 60 * 60 * 1000;
        if (now - Number(closedAt) < oneHour) return;
    }

    /* -------------------------
       3. Показ попапу з delay
    -------------------------- */
    const openPopup = () => {
        popup.classList.add("visible");
        popup.setAttribute("aria-hidden", "false");
    };

    setTimeout(openPopup, delay);

    /* -------------------------
       4. Закриття попапу
    -------------------------- */
    const closePopup = () => {
        popup.classList.remove("visible");
        popup.setAttribute("aria-hidden", "true");
        localStorage.setItem(CLOSED_KEY, Date.now());
    };

    closeBtn?.addEventListener("click", closePopup);
    overlay?.addEventListener("click", closePopup);

    /* -------------------------
       5. Успішна відправка форми → 30 днів
    -------------------------- */
    const successBox = popup.querySelector('.email-coupon__success[data-success="true"]');

    if (successBox) {
        localStorage.setItem(SUBMITTED_KEY, Date.now());
    }

});
